import { SortOrder } from '../types/common/commonTypes'

export const parseSortOrder = (param: string | null): [string, SortOrder][] => {
    if (!param) return []

    return param
        .split(';')
        .map(pair => pair.split(','))
        .filter(([field, order]) => !!field && !!order && Object.values(SortOrder).includes(order as SortOrder))
        .map(([field, order]) => [field, order as SortOrder])
}
